import { render, staticRenderFns } from "./transactionreport.vue?vue&type=template&id=1465e80c"
import script from "./transactionreport.vue?vue&type=script&lang=js"
export * from "./transactionreport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports